import React from 'react';
import { Image, Button, Carousel, Row, Col, Typography, Space, BackTop, Card } from 'antd';
import {
    BsArrowLeft,
    BsBook,
    BsTiktok,
    BsYoutube
} from 'react-icons/bs';
import {
    FaFacebookF,
    FaInstagram,
    FaTelegramPlane
} from 'react-icons/fa';

const { Title, Paragraph, Text } = Typography;

export default function Home({ survey, search }) {
    return (
        <>
            {/* القسم الرئيسي */}
            <section id="home" className="hero-section">
                <div className="container">
                    <Row gutter={[30, 30]} align="middle" justify="center">
                        <Col xs={24} lg={12}>
                            <div className="hero-content">
                                <img
                                    src={require('../style/img/home/logo.png')}
                                    className="hero-logo"
                                    alt="شعار أبناء المهندس"
                                />
                                <div className="quote-container">
                                    <Text className="quote-text">
                                        <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                                        <span> هؤلاء ابناء ابنائي كأنهم من لحمي ودمي </span>
                                        <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                                    </Text>
                                </div>
                                <Paragraph className="hero-description">
                                    مرحباً بكم في الموقع الرسمي لفريق أبناء المهندس والذي هو فريق طلابي متميز يجسد القيم الإنسانية والعلمية بأفضل صورها،
                                    حيث يسعى لتحقيق أهدافه من خلال تعزيز التفاعل الاجتماعي والتحصيل العلمي، في فريق أبناء المهندس نهدف إلى تحقيق الثأر لدماء القادة،
                                    وذلك من خلال تمثيل مبادئ وقيم الشهيد شهيد الامة الباسل ابي مهدي المهندس رضوان الله عليه.
                                </Paragraph>
                                {survey === "true" && search === "true" && (
                                    <Button type="primary" className="cta-button" icon={<BsBook />} href="/survey">
                                        أستمارة البحوث الجامعية
                                    </Button>
                                )}
                            </div>
                        </Col>
                        <Col xs={24} lg={12}>
                            <div className="hero-image-wrapper">
                                <Image
                                    src={require('../style/img/home/thum_vid.jpg')}
                                    alt="صورة أبناء المهندس"
                                    className="hero-image"
                                    preview={false}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <main>
                {/* قسم المهارات */}
                <section id="skill" className="section-light">
                    <div className="container">
                        <Row gutter={[30, 30]} align="middle">
                            <Col xs={24} md={12} order={2} orderMd={1}>
                                <div className="section-content">
                                    <Title level={2} className="section-title accent-primary">مهارة</Title>
                                    <Paragraph className="section-description">
                                        مبادرة لتدريب وتطوير الشباب برعاية المديرية العامة للعلاقات والخدمات الاجتماعية
                                    </Paragraph>
                                    <Button type="link" href="/skill" className="more-link">
                                        للمزيد <BsArrowLeft />
                                    </Button>
                                </div>
                            </Col>
                            <Col xs={24} md={12} order={1} orderMd={2}>
                                <div className="image-wrapper">
                                    <Image
                                        src={require('../style/img/home/mr33.jpg')}
                                        alt="مهارة"
                                        preview={false}
                                        className="feature-image"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                {/* قسم المنح الدراسية */}
                <section id="scholarships" className="section-white">
                    <div className="container">
                        <Row gutter={[30, 30]} align="middle">
                            <Col xs={24} md={12}>
                                <div className="image-wrapper">
                                    <Image
                                        src={require('../style/img/home/mr44.jpeg')}
                                        alt="منح دراسية"
                                        preview={false}
                                        className="feature-image"
                                    />
                                </div>
                            </Col>
                            <Col xs={24} md={12}>
                                <div className="section-content">
                                    <Title level={2} className="section-title accent-primary">منح دراسية</Title>
                                    <Paragraph className="section-description">
                                        انطلق نحو آفاق علمية جديدة
                                    </Paragraph>
                                    <Button type="link" href="/scholarships" className="more-link">
                                        للمزيد <BsArrowLeft />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                {/* قسم الرؤية */}
                <section id="seeing" className="vision-section">
                    <div className="container">
                        <div className="vision-content">
                            <Title level={2} className="vision-title">رؤيتنا</Title>
                            <Paragraph className="vision-description">
                                نموذج للشاب الجامعي و للفرق الطلابية الفاعلة و الهادفة التي يحلم اي طالب ان يكون جزء منها
                            </Paragraph>
                        </div>
                    </div>
                </section>

                {/* قسم الأهداف */}
                <section id="target" className="target-section">
                    <div className="container">
                        <Carousel autoplay className="target-carousel" dots={{ className: 'custom-dots' }}>
                            <div>
                                <div className="testimonial-item">
                                    <img
                                        src={require('../style/img/home/logo_w.png')}
                                        className="testimonial-img"
                                        alt="شعار أبناء المهندس"
                                    />
                                    <Paragraph className="testimonial-text">
                                        أبناء المهندس نحو الريادة والصدارة والتفوق بالمجال العلمي والعملي للطلبة
                                    </Paragraph>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </section>

                {/* قسم المهمات */}
                <section id="missions" className="missions-section">
                    <div className="container">
                        <div className="section-header">
                            <Title level={2} className="section-title accent-secondary">مهماتنا</Title>
                            <Paragraph className="section-description">
                                توفير بيئة تعليمية و تثقيفية و تنظيم فعاليات ثقافية و علمية واجتماعية تعكس مبادئنا
                                و تعزز التطور الشخصي و الاجتماعي لبناء تجمع طلابي يحتل المراكز العلمية الأولى في الجامعات والمعاهد
                            </Paragraph>
                        </div>

                        <Row gutter={[16, 16]} className="gallery-grid">
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr1.jpg')}
                                        alt="مهمة 1"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr2.jpg')}
                                        alt="مهمة 2"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr4.jpg')}
                                        alt="مهمة 3"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr6.jpg')}
                                        alt="مهمة 4"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr7.jpg')}
                                        alt="مهمة 5"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Card bordered={false} className="gallery-card">
                                    <Image
                                        src={require('../style/img/home/mr8.jpg')}
                                        alt="مهمة 6"
                                        className="gallery-image"
                                        preview={{ mask: false }}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </section>

                {/* قسم التواصل */}
                <section id="contact" className="contact-section">
                    <div className="container">
                        <Title level={2} className="section-title accent-secondary">تواصل معنا</Title>
                        <div className="contact-logo">
                            <img
                                src={require('../style/img/home/logo.png')}
                                alt="شعار أبناء المهندس"
                            />
                        </div>
                        <div className="social-icons-container">
                            <Space size="middle" className="social-icons">
                                <a className="social-icon facebook" href="https://www.facebook.com/almuhandise?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
                                    <FaFacebookF />
                                </a>
                                <a className="social-icon instagram" href="https://www.instagram.com/al_muhandise/?igsh=MXN1dHR4MW92MW42OA%3D%3D" target="_blank" rel="noopener noreferrer">
                                    <FaInstagram />
                                </a>
                                <a className="social-icon telegram" href="https://t.me/abnaaalmuhandis" target="_blank" rel="noopener noreferrer">
                                    <FaTelegramPlane />
                                </a>
                                <a className="social-icon tiktok" href="https://www.tiktok.com/@al_muhandise?_t=8mEv8PMnf4j&_r=1" target="_blank" rel="noopener noreferrer">
                                    <BsTiktok />
                                </a>
                                <a className="social-icon youtube" href="https://www.youtube.com/@abnaa_gen" target="_blank" rel="noopener noreferrer">
                                    <BsYoutube />
                                </a>
                            </Space>
                        </div>
                    </div>
                </section>
            </main>

            <BackTop className="back-to-top" />
        </>
    );
}